import React, { ReactElement, useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import monogrammeS from '@static/img/intro/s.png'
import monogrammeF from '@static/img/intro/f.png'

const useStyles = makeStyles((theme) => ({
  introAnimationRoot: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.secondary.main,
    transition: 'transform 0.3s ease-in',
    zIndex: 9999,
    '&.curton-off': {
      transition: 'transform 0.7s cubic-bezier(0.555, 0, 0.165, 1.000)',
      transformOrigin: 'left bottom',
      transform: 'translateY(-101vh)',
    },
    perspective: '200px',
  },

  monogramme: {
    position: 'relative',
    maxWidth: '90px',
    [theme.breakpoints.up('md')]: {
      maxWidth: '90px',
    },
    width: '100%',
  },
  monogrammeS: {
    position: 'relative',
    width: '100%',
    top: 0,
    left: 0,
    opacity: 0,
    transform: 'rotate3d(1, 1, 0, 90deg)',
    transition:
      'transform 1.3s cubic-bezier(0.645, 0.045, 0.355, 1.000), opacity 0.5s ease',
    '&.step1': {
      opacity: 1,
      transform: 'rotate3d(1, 1, 0, 0deg)',
    },
  },
  monogrammeF: {
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    opacity: 0,
    transformOrigin: 'bottom center',
    transform: 'rotate3d(1, 0, 0, -90deg)',
    transition:
      'transform 1.3s cubic-bezier(0.645, 0.045, 0.355, 1.000), opacity 0.5s ease',
    '&.step2': {
      opacity: 1,
      transform: 'rotate3d(1, 0, 0, 0deg)',
    },
  },
}))

export type IIntroAnimationPros = {
  onBeforeComplete?: () => void
  onComplete?: () => void
}

export default function AnimationPros({
  onBeforeComplete,
  onComplete,
}: IIntroAnimationPros): ReactElement {
  const classes = useStyles()
  const [introStatus, setIntroStatus] = useState('start')

  useEffect(() => {
    let mounted = true
    if (mounted) {
      setTimeout(() => {
        setIntroStatus('step1')
      }, 1000)
      setTimeout(() => {
        setIntroStatus('step1 step2')
      }, 1600)
      setTimeout(() => {
        setIntroStatus('step1 step2 curton-off')
        if (onBeforeComplete) {
          onBeforeComplete()
        }
      }, 3500)
      setTimeout(() => {
        if (onComplete) {
          onComplete()
        }
      }, 4200)
    }
    return () => {
      mounted = false
    }
  }, [])

  return (
    <div
      className={clsx(
        classes.introAnimationRoot,
        'intro-animation',
        introStatus
      )}
    >
      <div className={classes.monogramme}>
        <img
          src={monogrammeS}
          className={clsx(classes.monogrammeS, introStatus)}
        />
        <img
          src={monogrammeF}
          className={clsx(classes.monogrammeF, introStatus)}
        />
      </div>
    </div>
  )
}
